import { Container, ScrollArea, Table, Center, Text, Loader, Group, Paper, Pagination, Stack, Tabs, Tooltip, UnstyledButton } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { faPlaneLock } from '@fortawesome/free-solid-svg-icons';
import { BarChart } from '@mantine/charts';
import '@mantine/charts/styles.css';

const recordsPerPage = 20;

const TableWithLoaderCifrasRDI = ({ heigth, allData, headers }) => {

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const totalPages = Math.ceil(allData.length / recordsPerPage);


    return (
        <>
            <div style={{ gridColumn: '1 / -1' }}>
                <Tabs defaultValue="Cifras">
                    <Tabs.List >
                        <Tabs.Tab value="Cifras">Cifras de control</Tabs.Tab>
                        <Tabs.Tab value="KPI">KPI de cifras de control</Tabs.Tab>
                    </Tabs.List>
                    <Tabs.Panel value="Cifras" pt="xs">
                        <Paper shadow="xl" radius="xl" withBorder p="xl">
                            {loading ? (
                                <Center h={heigth}>
                                    <Loader color="rgba(250, 0, 115, 1)" type="dots" size={100} />
                                </Center>
                            ) : allData.length !== 0 ? (
                                <ScrollArea h={heigth}>
                                    <Table stickyHeader>
                                        <Table.Thead>
                                            <Table.Tr>
                                                {headers.map((header, index) => (
                                                    <Table.Th key={index} style={{ textAlign: 'center' }}>
                                                        {header}
                                                    </Table.Th>
                                                ))}
                                            </Table.Tr>
                                        </Table.Thead>
                                        <Table.Tbody>
                                            {allData.map((row, rowIndex) => (
                                                <Table.Tr key={rowIndex}>
                                                    {headers.map((header, colIndex) => (
                                                        <Table.Td key={colIndex} style={{ textAlign: 'center' }}>
                                                            {row[header] ?? '-'}
                                                        </Table.Td>
                                                    ))}
                                                </Table.Tr>
                                            ))}
                                        </Table.Tbody>
                                    </Table>
                                </ScrollArea>
                            ) : (
                                <Center h={heigth}>
                                    <Container>
                                        <Text c="dimmed" size="lg" ta="center" p={36}>
                                            Sin datos encontrados
                                        </Text>
                                        <Text c="dimmed" size="lg" ta="center">
                                            <FontAwesomeIcon icon={faPlaneLock} size="3x" />
                                        </Text>
                                    </Container>
                                </Center>
                            )}
                        </Paper>
                        {/* Pagination control */}
                        {!loading && totalPages > 1 && (
                            <div style={{ gridColumn: '1 / -1' }}>
                                <Stack spacing="md" align="flex-end">
                                    <Paper height={2} shadow="lg" radius="lg" withBorder p="sm">
                                        <Pagination
                                            color="rgba(2, 12, 65, 1)"
                                            total={totalPages}
                                            value={currentPage}
                                            onChange={setCurrentPage}
                                        />
                                    </Paper>
                                </Stack>
                            </div>
                        )}
                    </Tabs.Panel>

                    <Tabs.Panel value="KPI" pt="xs">
                       <BarChart
                            h={300}
                            data={allData}
                            dataKey="MES"
                            series={
                                [
                                    { name: 'AWB', color: 'teal.6' },
                                    { name: 'CCA', color: 'teal.6' },
                                    { name: 'CTM', color: 'teal.6' },
                                    { name: 'FLN', color: 'teal.6' },
                                    { name: 'IBC', color: 'teal.6' },
                                    { name: 'IMP', color: 'teal.6' },
                                ]}                                                        
                        />
                    </Tabs.Panel>
                </Tabs>
            </div>

            <div style={{ gridColumn: '1 / -1' }}>

            </div>


        </>
    );
};

export default TableWithLoaderCifrasRDI;